export default ['code', 'qr', 'nfc', 'ocr', 'ocr-typed', 'check', 'extqr', 'extnfc', 'otp', 'tid'];
